
export const getRetries = (state) => state.countRetries;

export const getSmsTime = (state) => state.smsTime;

export const getSmsInfo = (state) => state.smsCreatedInfo;

export const getSmsValidatedData = (state) => state.validationSmsData;

export const getOtpValidatedData = (state) => state.smsValidated;

export const getUserNotFound = (state) => state.userNotFound;

export const getUserIsBlocked = (state) => state.userIsBlocked;
